import { render, staticRenderFns } from "./AdminFeedbackView.vue?vue&type=template&id=4c53b219&scoped=true"
import script from "./AdminFeedbackView.vue?vue&type=script&lang=js"
export * from "./AdminFeedbackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c53b219",
  null
  
)

export default component.exports